const fabricatorService = {
  title: "Fabricator",
  icon: "🛠️",
  shortDescription:
    "Metal fabrication support, frame correction, grill work, and custom structure fitting.",
  longDescription:
    "Book fabrication support for basic metal structure work, correction, reinforcement, and installation-oriented tasks. Larger or custom fabrication jobs may require inspection first.",
  consultationNote:
    "Custom fabrication, cutting plans, or major metal structure execution should begin with inspection.",
  responsePromise:
    "Assignment depends on task scope, metalwork nature, and available fabricator fit.",
  warrantyPolicy:
    "Support depends on execution type, structure load, and material condition.",
  subServices: [
    {
      id: "fabricator-small-frame-job",
      title: "Small Frame Fabrication",
      icon: "🧱",
      group: "Fabrication",
      description:
        "Small metal frame support or fabrication work for household or site needs.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "fabricator-grill-modification",
      title: "Grill Modification",
      icon: "🪟",
      group: "Modification",
      description:
        "Minor grill extension, reduction, or modification work where feasible.",
      basePrice: 1199,
      priceType: "starts_at",
      duration: "2-5 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "fabricator-structure-repair",
      title: "Metal Structure Repair",
      icon: "🔩",
      group: "Repair",
      description:
        "Repair broken support joints, cracked sections, or damaged metal frame points.",
      basePrice: 999,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "fabricator-inspection",
      title: "Fabrication Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for custom metalwork, estimate planning, or structure assessment.",
      basePrice: 399,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default fabricatorService;